import React, { useState, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { newsSave } from '../../../store/actions/websiteActions'
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { Upload, message } from 'antd';
import { LoadingOutlined, PlusOutlined } from '@ant-design/icons';
import 'suneditor/dist/css/suneditor.min.css';
import SunEditor from 'suneditor-react';
import MyCustomUploadAdapterPlugin from '../../../components/UploadFileCK';

const NewsCreate = () => {
  const [type, settype] = useState('')
  const [title, settitle] = useState('')
  const [intro, setintro] = useState('')
  const [publishdate, setpublishdate] = useState('')
  const [status, setstatus] = useState('')
  const [content, setcontent] = useState('')
  const [contentplain, setcontentplain] = useState('')
  const [file, setfile] = useState([])
  const [image, setimage] = useState()
  const [whatsAppButtonEnable, setwhatsappbuttonEnable] = useState(false)
  const [loading, setloading] = useState(false)
  
  let dispatch = useDispatch()
  let history = useHistory()

  const datanewsSave = useSelector(state => state.newsSave)
  const { validation } = datanewsSave

  const dataLogin = useSelector(state => state.login)
  const { userInfo } = dataLogin
  const created_by = userInfo.user.id

  const handleSubmit = (e) => {
    e.preventDefault();
    dispatch(newsSave(type, title, intro, content, contentplain, publishdate, status, file, created_by, history, whatsAppButtonEnable))
  }
  
  function getBase64(img, callback) {
    const reader = new FileReader();
    reader.addEventListener('load', () => callback(reader.result));
    reader.readAsDataURL(img);
  }
  
  function beforeUpload(file) {
    setloading(true)
    const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
    if (!isJpgOrPng) {
      message.error('You can only upload JPG/PNG file!');
    }
    const isLt2M = file.size / 1024 / 1024 < 2;
    if (!isLt2M) {
      message.error('Image must smaller than 2MB!');
    }
    return isJpgOrPng && isLt2M;
  }

  const uploadButton = (
    <div>
      {loading ? <LoadingOutlined /> : <PlusOutlined />}
      <div style={{ marginTop: 8 }}>Upload</div>
    </div>
  );

  const handleChange = (info) => {
    setfile(info.file.originFileObj)
    getBase64(info.file.originFileObj, imageUrl =>
      setimage(imageUrl),
      setloading(false)
    );
  };

    useEffect(() => {
          if (!userInfo || !userInfo.permission) return;
    if (userInfo.user.roles[0].name == "Super Admin") return;
      if (!userInfo.permission.includes("news-create")) window.location.href = process.env.REACT_APP_LINK_REDIRECT + "403";
    }, []);

  return (
    <div className="">
      <div className="page-title">
        <div className="title_left">
          <h3>Create News</h3>
        </div>
      </div>
      <div className="clearfix"></div><br/>
      <div className="row">
        <div className="col-md-12 col-sm-12 col-xs-12 col-lg-6">
          <div className="x_panel">
            <div className="x_title">
              <h2>Form Input</h2>
              <div className="clearfix"></div>
            </div>
            
            <div className="x_content overflow-auto">  
              <form onSubmit={(e) => handleSubmit(e)}>
                <div className="form-group">
                  <label for="name">Type</label>
                  <select 
                    className={ validation.length !== 0 && validation['type'] ? 'form-control parsley-error' : 'form-control' }
                    required
                    onChange={(e) => settype(e.target.value)}
                  >
                    <option disabled selected value="">Select Type</option>
                    <option value="default">Default</option>
                    <option value="the_pulse">The Pulse</option>
                  </select>
                  {
                    validation.length !== 0 
                    ?
                      <ul className="parsley-errors-list filled">
                        <li className="parsley-required">{validation['type']}</li>
                      </ul>
                    :
                      null
                  }
                </div>

                <div className="form-group">
                  <label for="name">Title</label>
                  <input type="text" className={ validation.length !== 0 && validation['type'] ? 'form-control parsley-error' : 'form-control' }
                  required onChange={(e) => settitle(e.target.value)} />
                  {
                    validation.length !== 0 
                    ?
                      <ul className="parsley-errors-list filled">
                        <li className="parsley-required">{validation['type']}</li>
                      </ul>
                    :
                      null
                  }
                </div>

                <div className="form-group">
                  <label for="name">Intro</label>
                  <textarea className={ validation.length !== 0 && validation['intro'] ? 'form-control parsley-error' : 'form-control' } required onChange={(e) => setintro(e.target.value)}>

                  </textarea>
                  {
                    validation.length !== 0 
                    ?
                      <ul className="parsley-errors-list filled">
                        <li className="parsley-required">{validation['intro']}</li>
                      </ul>
                    :
                      null
                  }
                </div>

                <div className="form-group">
                  <label for="name">Content</label>
                    {/* <CKEditor
                      editor={ ClassicEditor }
                      data=""
                      config={{
                        extraPlugins: [ MyCustomUploadAdapterPlugin ],
                        // ckfinder: {
                        //   uploadUrl: process.env.REACT_APP_API_URL+'uploads'
                        // }
                      }}
                      onChange={ ( event, editor ) => {
                          const data = editor.getData();
                          var plainString = data.replace(/<[^>]+>/g, '');
                          setcontent(data)
                          console.log("plain string : ",  plainString)
                          setcontentplain(plainString)
                          // console.log( { event, editor, data, plainString } );
                      } }
                    /> */}
                     <SunEditor
                      setContents={content}
                      onChange={(e) => {
                        setcontent(e)
                        setcontentplain(e.replace(/<[^>]+>/g, ''))
                      }}
                      height="400px"
                      setOptions={{
                        buttonList: [
                          ['undo', 'redo', 'font', 'fontSize', 'formatBlock'],
                          ['bold', 'underline', 'italic', 'strike'],
                          ['fontColor', 'hiliteColor'],
                          ['align', 'list', 'table'],
                          ['link'],
                          ['fullScreen', 'showBlocks', 'codeView'],
                        ]
                      }}
                    />
                  {
                    validation.length !== 0 
                    ?
                      <ul className="parsley-errors-list filled">
                        <li className="parsley-required">{validation['content']}</li>
                      </ul>
                    :
                      null
                  }
                </div>

                <div className="row">
                  <div className="col-md-6 col-sm-6 col-xs-12">
                    <div className="form-group">
                      <div class="form-check form-switch">
                        <input class="form-check-input" type="checkbox" role="switch" id="switchCheckDefault" onChange={(e) => setwhatsappbuttonEnable(e.target.checked) }/>
                        <label class="form-check-label" for="switchCheckDefault">Enable Whatsapp Button</label>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="col-md-6 col-sm-6 col-xs-12">
                    <div className="form-group">
                      <label for="name">Publish Date</label>
                      <input type="date" 
                        className={ validation.length !== 0 && validation['publish_date'] ? 'form-control parsley-error' : 'form-control' }
                        onChange={(e) => setpublishdate(e.target.value)}
                      />
                      {
                        validation.length !== 0 
                        ?
                          <ul className="parsley-errors-list filled">
                            <li className="parsley-required">{validation['publish_date']}</li>
                          </ul>
                        :
                          null
                      }
                    </div>
                  </div>
                  <div className="col-md-6 col-sm-6 col-xs-12">
                    <div className="form-group">
                      <label for="name">Status</label>
                      <select 
                        className={ validation.length !== 0 && validation['status'] ? 'form-control parsley-error' : 'form-control' }
                        required onChange={(e) => setstatus(e.target.value)}
                      >
                        <option disabled selected value="">Select Status</option>
                        <option value="1">Active</option>
                        <option value="0">Deactive</option>
                      </select>
                      {
                        validation.length !== 0 
                        ?
                          <ul className="parsley-errors-list filled">
                            <li className="parsley-required">{validation['status']}</li>
                          </ul>
                        :
                          null
                      }
                    </div>
                  </div>
                </div>
                <div className="form-group">
                  <label for="name">Image</label>
                  <Upload
                    name="avatar"
                    listType="picture-card"
                    className="avatar-uploader"
                    showUploadList={false}
                    beforeUpload={beforeUpload}
                    onChange={handleChange}
                  >
                    {image ? <img src={image} alt="avatar" style={{ width: '100%' }} /> : uploadButton}
                  </Upload>
                  {
                    validation.length !== 0 
                    ?
                      <ul className="parsley-errors-list filled">
                        <li className="parsley-required">{validation['image']}</li>
                      </ul>
                    :
                      null
                  }
                </div>
                <button type="submit" className="btn btn-primary pull-right">Submit</button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default NewsCreate
